// /src/Pages/Profile.js
import React from 'react';
import { Typography, Box } from '@mui/material';

const Profile = () => (
  <Box sx={{ textAlign: 'center', mt: 5 }}>
    <Typography variant="h4">Profile</Typography>
    <Typography variant="body1">This is the Profile section.</Typography>
  </Box>
);

export default Profile;